import { jsx as _jsx } from "react/jsx-runtime";
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
const MenuItem = styled(Menu.Item)`
  &:hover {
    background-color: var(--red-10);
    color: var(--red-60);
  }
  span {
    flex: 1;
  }
`;
const BaseDelete = (params)=>{
    const { danger = true, icon = /*#__PURE__*/ _jsx(FontAwesomeIcon, {
        icon: faTrash
    }), children } = params;
    return /*#__PURE__*/ _jsx(MenuItem, {
        danger: danger,
        icon: icon,
        ...params,
        children: children || /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "delete"
        })
    });
};
export const Delete = withHideIfNotAllowed(BaseDelete);
